export default __webpack_public_path__ + "static/media/ic-doge-bep20.9dc67831.svg";